import { render, staticRenderFns } from "./MessageTraffic.vue?vue&type=template&id=fb01b644&scoped=true"
import script from "./MessageTraffic.vue?vue&type=script&lang=js"
export * from "./MessageTraffic.vue?vue&type=script&lang=js"
import style0 from "./MessageTraffic.vue?vue&type=style&index=0&id=fb01b644&prod&lang=scss"
import style1 from "./MessageTraffic.vue?vue&type=style&index=1&id=fb01b644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb01b644",
  null
  
)

export default component.exports